export const BACKEND_URL = "https://cheda-gaming-api.onrender.com";
export const FLW_PBLK = "FLWPUBK-42324bf66578bd6b3b872db540ef2a90-X";
// export const FLW_PBLK = "FLWPUBK_TEST-8496e96ae6bd103e18415cb799840f51-X";
export const LOGO_URL = "https://www.chedagaming.com/images/chedagaming_logo.png";